import { FC, Fragment } from 'react'
import styled from 'styled-components'
import { BotMessageList } from './BotMessageList'
import { UserMessageList } from './UserMessageList'
import { Avatar } from '../Avatar'
import { useRecoilValue } from 'recoil'
import { messageListState } from '../../states/messageState'

export const MessageSection: FC = () => {
  const messageItems = useRecoilValue(messageListState)

  return (
    <StyledContainer>
      <StyledMessageHead>
        <StyledAvatarWrap>
          <Avatar size={80}>
            <img src="/navigater.png" alt="" />
          </Avatar>
        </StyledAvatarWrap>
        何か手伝えることはありますか？
        <br />
        なんでもお問い合わせください！
      </StyledMessageHead>
      {messageItems.map((item, index) => (
        <Fragment key={`${index}_${item.messages[index]}`}>
          {item.sender === 'bot' ? (
            <BotMessageList key={index} messageItem={item} />
          ) : (
            item.sender === 'user' && <UserMessageList key={index} messageItem={item} />
          )}
        </Fragment>
      ))}
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  width: 100%;
  max-width: 673px;
  min-width: 325px;
  background: #fff;
  height: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding: 0px 24px 16px;

  @media (max-width: 767px) {
    padding: 0px 10px 16px;
  }
`
const StyledMessageHead = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 80px;
  font-size: 18px;
`
const StyledAvatarWrap = styled.div`
  margin-bottom: 20px;
`
